import axios from 'axios';
import { getApiBaseUrl } from '../../config/api';
import {
    getRequest,
    getSuccess,
    getFailed,
    teacherDetailLoadFailed,
    getError,
    doneSuccess
} from './teacherSlice';

export const fetchTeacherTemporaryEmail = async () => {
    const result = await axios.get(`${getApiBaseUrl()}/TeacherTemporaryEmail`);
    if (result.data?.message && !result.data?.email) {
        throw new Error(result.data.message);
    }
    return result.data?.email || null;
};

export const getAllTeachers = (id) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.get(`${getApiBaseUrl()}/Teachers/${id}`);
        if (result.data.message) {
            dispatch(getFailed(result.data.message));
        } else {
            dispatch(getSuccess(result.data));
        }
    } catch (error) {
        dispatch(getError(error));
    }
}

export const getTeacherDetails = (id) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.get(`${getApiBaseUrl()}/Teacher/${id}`);
        const data = result.data;
        if (data?.message && !data?._id && !data?.id) {
            dispatch(teacherDetailLoadFailed(data.message));
        } else if (data) {
            dispatch(doneSuccess(data));
        }
    } catch (error) {
        dispatch(getError(error));
    }
}

export const resetTeacherSalaryCycle = (teacherId) => async (dispatch) => {
    dispatch(getRequest());
    try {
        const result = await axios.put(`${getApiBaseUrl()}/Teacher/${teacherId}/salary-reset`, {}, {
            headers: { "Content-Type": "application/json" },
        });
        if (result.data?.message && !result.data?.id && !result.data?._id) {
            dispatch(getFailed(result.data.message));
        } else {
            dispatch(doneSuccess(result.data));
        }
    } catch (error) {
        dispatch(getError(error.response?.data?.message || error.message));
    }
};

export const updateTeachSubject = (teacherId, teachSubject) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.put(`${getApiBaseUrl()}/TeacherSubject`, { teacherId, teachSubject }, {
            headers: { 'Content-Type': 'application/json' },
        });
        const data = result.data;
        if (data?.message && !data?._id && !data?.id && !data?.teachSubjects) {
            dispatch(getFailed(data.message));
            return { success: false, message: data.message };
        }
        dispatch(doneSuccess(data));
        return { success: true, data };
    } catch (error) {
        dispatch(getError(error));
        return { success: false };
    }
};

export const removeTeachSubject = (teacherId, teachSubject) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.delete(`${getApiBaseUrl()}/TeacherSubject`, {
            data: { teacherId, teachSubject },
            headers: { 'Content-Type': 'application/json' },
        });
        const data = result.data;
        if (data?.message && !data?._id && !data?.id && !data?.teachSubjects) {
            dispatch(getFailed(data.message));
            return { success: false, message: data.message };
        }
        dispatch(doneSuccess(data));
        return { success: true, data };
    } catch (error) {
        dispatch(getError(error));
        return { success: false };
    }
};

export const updateTeacher = (id, fields) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.put(`${getApiBaseUrl()}/Teacher/${id}`, fields, {
            headers: { 'Content-Type': 'application/json' },
        });
        if (result.data?.message && !result.data?._id && !result.data?.id) {
            dispatch(getFailed(result.data.message));
            return { success: false, message: result.data.message };
        }
        dispatch(doneSuccess(result.data));
        return { success: true, data: result.data };
    } catch (error) {
        dispatch(getError(error));
        const msg = error.response?.data?.message || error.message || "Could not update teacher";
        return { success: false, message: msg };
    }
};

export const logTeacherAttendance = (teacherId, payload) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.post(`${getApiBaseUrl()}/TeacherAttendance/${teacherId}`, payload, {
            headers: { 'Content-Type': 'application/json' },
        });
        if (result.data?.message && !result.data?._id && !result.data?.id) {
            dispatch(getFailed(result.data.message));
        } else {
            dispatch(doneSuccess(result.data));
        }
    } catch (error) {
        dispatch(getError(error));
    }
};